export const useStoreClass = defineStore('StoreClass', {
    state: () => ({
        item: null,
        error: null,
    }),
    actions: {
        async getClass(classSlug) {
            this.error = null;
            this.item = null;
            ({item: this.item, error: this.error} = await useEntityClass().get(classSlug));
        },
    },
    getters: {
        details() {
            if (!this.item) return null;
            return {
                id: this.item.id_class,
                slug: this.item.class_slug,
                name: this.item.class_name,
                address: this.item.class_address,
                website: this.item.class_website,
                description: this.item.class_description,
                lat: this.item.class_latitude,
                lng: this.item.class_longitude,
            };
        },
    },
});
